document.addEventListener('contextmenu', event => event.preventDefault());

document.addEventListener('DOMContentLoaded', function(){
    const allImg = document.querySelectorAll('img');

    if(allImg.length > 0) {
        allImg.forEach(function(img) {
            img.setAttribute('draggable', false);
        });
    }
});